import { Component, computed, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Loading } from '../../../../core/services/loading';
@Component({
  selector: 'app-progress-spinner',
  imports: [MatProgressSpinnerModule],
  templateUrl: './progress-spinner.html'
})
export class ProgressSpinner {
  private readonly loading = inject(Loading);
  isLoading = computed(() => this.loading.isLoading());
}
